import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';

import Info, { Item, Metric } from '../../Info';
import { startEditAdmin } from '../../../store/actions/admin';
import { selectReceiptMetrics } from '../../../store/selectors/metrics';

const styles = theme => ({
  root: {
    minWidth: '250px',
  },
  section: {
    marginTop: theme.spacing.unit*2,
    marginBottom: theme.spacing.unit*2,
    display: 'flex',
    flexDirection: 'column',
  },
  heading: {
    marginTop: theme.spacing.unit*2,
    marginBottom: theme.spacing.unit*2,
    textAlign: 'center',
  }
});


const ReceiptsCardsSide = ({ metrics, startEditAdmin }) => {
  return(
    <Info title="Receipt KPIs">
      {metrics.map((metric, i) => {
        return (
          <Item key={i}>
            <Metric
              type={metric.type}
              label={metric.label}
              value={metric.display} />
          </Item>
        );
      })}
    </Info>
  );
};

const mapStateToProps = (state) => ({
  metrics: selectReceiptMetrics(state),
});

const mapDispatchToProps = (dispatch) => ({
  startEditAdmin: (bid) => dispatch(startEditAdmin(bid)),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(ReceiptsCardsSide);



// WEBPACK FOOTER //
// ./src/components/admin/Receipts/ReceiptsCardsSide.jsx